import { Component } from '@angular/core';
import { WorkflowItemKeyDirective } from '@workflow/directives/workflow-item-key/workflow-item-key.directive';

@Component({
	selector: 'workflow-optische-reaktion-epilog',
	templateUrl: './optische-reaktion-epilog.component.html',
	styleUrls: ['./optische-reaktion-epilog.component.scss']
})
export class OptischeReaktionEpilogComponent {
	constructor(public workflowItemKey: WorkflowItemKeyDirective<ReadonlyMap<number, number>>) {}
}
